module.exports = __webpack_public_path__ + "media/images/aloe/illustrations/store-d09da53a09bf697951f201722e566fa3.svg";